import { render, staticRenderFns } from "./MlDownload.vue?vue&type=template&id=467341c9"
import script from "./MlDownload.vue?vue&type=script&lang=js"
export * from "./MlDownload.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports